import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { selectProfileForFocussedEvent } from "../redux/selectors";
import MapContainer from "./MapContainer";
import {} from "../redux/actions";
import { Avatar, TextField, Typography } from "@material-ui/core";
import WorkIcon from "@material-ui/icons/Work";

const styles = theme => ({
    paper: {
        position: "absolute",
        width: theme.spacing.unit * 55,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit,
        overflow: "visible"
    },

    margin: {
        margin: theme.spacing.unit
    },
    avatar: {
        margin: 10,
        padding: 10,
        backgroundColor: "rgb(63,81,181)"
    },
    bigAvatar: {
        width: "130px",
        height: "130px",
        display: "block",
        margin: "0 auto"
    },
    noImageAvatar: {
        width: "130px",
        height: "130px"
    },
    container: {
        display: "flex",
        flexWrap: "wrap"
    },
    textField: {
        // marginLeft: theme.spacing.unit,
        // marginRight: theme.spacing.unit
    },
    dense: {
        marginTop: 16
    },
    menu: {
        width: 200
    }
});

class JobpacksDetail extends React.Component {
    handleChange = name => event => {
        this.setState({
            [name]: event.target.value
        });
    };

    state = {
        name: "Cat in the Hat",
        age: "",
        multiline: "Controlled",
        currency: "EUR"
    };

    render() {
        const { classes, profile } = this.props;
        return (
            <div className="EmployeesDetail">
                <div className="EmployeesDetail-avatar">
                    <Typography
                        style={{
                            gridRowStart: 1,
                            gridRowEnd: 1,
                            gridColumnStart: 1,
                            gridColumnEnd: 3
                        }}
                    >
                        Jobpack Profile
                    </Typography>
                    <Avatar
                        alt="profile avatar"
                        className={
                            profile["profile_image_url"]
                                ? classes.bigAvatar
                                : classes.noImageAvatar
                        }
                        src={profile["profile_image_url"] || null}
                        style={{
                            gridColumnStart: 1,
                            gridColumnEnd: 3,
                            gridRowStart: 2,
                            gridRowEnd: 3,
                            alignSelf: "center",
                            justifySelf: "center"
                        }}
                    >
                        {profile["profile_image_url"] || (
                            <WorkIcon style={{ fontSize: 60 }} />
                        )}
                    </Avatar>
                    <div
                        className={"EmployeeDetailText"}
                        style={{
                            gridRowStart: 3,
                            gridRowEnd: 4,
                            gridColumnStart: 1,
                            gridColumnEnd: 1
                        }}
                    >
                        <TextField
                            label="Name"
                            margin="normal"
                            variant="filled"
                            InputProps={{
                                readOnly: true
                            }}
                            value={profile["job_name"]}
                            style={{
                                width: "100%"
                            }}
                        />
                    </div>
                    <div
                        className={"EmployeeDetailText"}
                        style={{
                            gridRowStart: 3,
                            gridRowEnd: 4,
                            gridColumnStart: 2,
                            gridColumnEnd: 2
                        }}
                    >
                        <TextField
                            label="ID"
                            margin="normal"
                            variant="filled"
                            InputProps={{
                                readOnly: true
                            }}
                            value={profile["job_id"]}
                            style={{ width: "100%" }}
                        />
                    </div>
                </div>
                <div className="EmployeesDetail-qualifications">
                    <div
                        className={"EmployeeDetailText"}
                        style={{
                            gridRowStart: 1,
                            gridRowEnd: 2,
                            gridColumnStart: 1,
                            gridColumnEnd: 1
                        }}
                    >
                        <TextField
                            label="Manager"
                            margin="normal"
                            variant="filled"
                            InputProps={{
                                readOnly: true
                            }}
                            value={profile["assigned_manager"]}
                            style={{ width: "100%" }}
                        />
                    </div>
                    <div
                        className={"EmployeeDetailText"}
                        style={{
                            gridRowStart: 2,
                            gridRowEnd: 3,
                            gridColumnStart: 1,
                            gridColumnEnd: 1
                        }}
                    >
                        <TextField
                            label="Supervisor"
                            margin="normal"
                            variant="filled"
                            InputProps={{
                                readOnly: true
                            }}
                            value={profile["assigned_supervisor"]}
                            style={{ width: "100%" }}
                        />
                    </div>
                    <div
                        className={"EmployeeDetailText"}
                        style={{
                            gridRowStart: 3,
                            gridRowEnd: 4,
                            gridColumnStart: 1,
                            gridColumnEnd: 1
                        }}
                    >
                        <TextField
                            label="Operatives"
                            margin="normal"
                            variant="filled"
                            InputProps={{
                                readOnly: true
                            }}
                            value={profile["assigned_operatives"]}
                            style={{ width: "100%" }}
                        />
                    </div>
                    <div
                        className={"EmployeeDetailText"}
                        style={{
                            gridRowStart: 1,
                            gridRowEnd: 2,
                            gridColumnStart: 2,
                            gridColumnEnd: 2
                        }}
                    >
                        <TextField
                            label="Client"
                            margin="normal"
                            variant="filled"
                            InputProps={{
                                readOnly: true
                            }}
                            value={profile["client_name"]}
                            style={{ width: "100%" }}
                        />
                    </div>
                    <div
                        className={"EmployeeDetailText"}
                        style={{
                            gridRowStart: 2,
                            gridRowEnd: 3,
                            gridColumnStart: 2,
                            gridColumnEnd: 2
                        }}
                    >
                        <TextField
                            label="Address"
                            margin="normal"
                            variant="filled"
                            InputProps={{
                                readOnly: true
                            }}
                            value={profile["address"]}
                            style={{ width: "100%" }}
                        />
                    </div>
                    <div
                        className={"EmployeeDetailText"}
                        style={{
                            gridRowStart: 3,
                            gridRowEnd: 4,
                            gridColumnStart: 2,
                            gridColumnEnd: 2
                        }}
                    >
                        <TextField
                            label="Status"
                            margin="normal"
                            variant="filled"
                            InputProps={{
                                readOnly: true
                            }}
                            value={profile["status"]}
                            style={{ width: "100%" }}
                        />
                    </div>
                    <div
                        style={{
                            gridRowStart: 1,
                            gridRowEnd: 5,
                            gridColumnStart: 3,
                            gridColumnEnd: 3
                        }}
                    >
                        <MapContainer
                            lat={profile["location_lat"]}
                            long={profile["location_long"]}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(
    connect(
        store => {
            return { profile: selectProfileForFocussedEvent(store) };
        },
        {}
    )(JobpacksDetail)
);
